export const isTagWrapped = (parent: Element, child: Element) => {
  const itemRect = child.getBoundingClientRect();
  const containerRect = parent.getBoundingClientRect();
  const itemStyles = window.getComputedStyle(child);
  const itemFullHeight =
    itemRect.height + parseInt(itemStyles.marginTop, 10) + parseInt(itemStyles.marginBottom, 10);

  return Math.round(itemRect.top - itemFullHeight * 2) > containerRect.top;
};
